import BaseSetup from '@/components/BaseSetup';
import { i18n } from '@/i18n';
import { useMissionPlaceClientService } from '@/services/MissionPlaceClientService';
import { Reactive } from '@/utils/decorators';

export type SharedMissionPlaceSelectEmits = {
	(e: 'input', val: number): void
	(e: 'update:missionPlace', val: IMissionPlaceDropDownListItemModel): void
};

export type SharedMissionPlaceSelectProps = {
	label?: string
	value?: number
	missionPlace?: IMissionPlaceModel
};

export default class SharedMissionPlaceSelectSetup extends BaseSetup {

	static readonly defaultProps = { label: i18n.global.t('common.selectMissionPlace') };

	@Reactive private readonly state = {
		dataLoaded: false,
		options: [] as IMissionPlaceDropDownListItemModel[],
	};

	get dataLoaded () { return this.state.dataLoaded }
	get options () { return this.state.options }

	get missionPlaceId () { return this.props.value as number }
	set missionPlaceId (val: number) {
		this.emits('input', val);
		const value = this.options.find((x: IMissionPlaceDropDownListItemModel) => x.id === val);
		if (value)
			this.emits('update:missionPlace', value);
	}

	constructor (
		private props: SharedMissionPlaceSelectProps,
		private emits: SharedMissionPlaceSelectEmits,
	) {
		super();
	}

	protected async onBeforeMountAsync () {
		this.state.options = await useMissionPlaceClientService().listAsync();
		this.state.dataLoaded = true;
	}

}
